var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.5C11 6.70914 9.20914 8.5 7 8.5C4.79086 8.5 3 6.70914 3 4.5C3 2.29086 4.79086 0.5 7 0.5C9.20914 0.5 11 2.29086 11 4.5Z",
    fill: "#079F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15C14 16.933 10.866 18.5 7 18.5C3.13401 18.5 0 16.933 0 15C0 13.067 3.13401 11.5 7 11.5C10.866 11.5 14 13.067 14 15Z",
    fill: "#079F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 11.75C13.25 12.1642 13.5858 12.5 14 12.5C14.4142 12.5 14.75 12.1642 14.75 11.75V10.25H16.25C16.6642 10.25 17 9.91421 17 9.5C17 9.08579 16.6642 8.75 16.25 8.75H14.75V7.25C14.75 6.83579 14.4142 6.5 14 6.5C13.5858 6.5 13.25 6.83579 13.25 7.25V8.75L11.75 8.75C11.3358 8.75 11 9.08579 11 9.5C11 9.91421 11.3358 10.25 11.75 10.25L13.25 10.25V11.75Z",
    fill: "#079F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.b9310730365ddb23471081d593e213e3.svg";
export { ForwardRef as ReactComponent };